/**
 * Created by Andrey Popov on 11/17/21.
 */

const MissionsTool = {
    getToolItems: function () {
        const missionActions = {
            "clear finished": this.getLastRemoved()
        };

        const locations = {
            "main": []
        };

        cleverapps.meta.listAvailableLocations().forEach((locationId) => {
            const locationMeta = cleverapps.meta.getLocationMeta(locationId);
            if (!locationMeta.locationConfig.isMain) {
                locations[locationId] = [];
            }
        });

        cleverapps.missionManager.getExistingTypes().forEach((missionType) => {
            if ([Mission.TYPE_SNAIL_FEAST, Mission.TYPE_EXPEDITION_FEAST, Mission.TYPE_EXPEDITION_PASS].includes(missionType)) {
                return;
            }

            const missionData = Missions[missionType];
            if (missionData.abTest && !missionData.abTest()) {
                return;
            }

            locations[missionData.location || "main"].push(missionType);
        });

        const expeditionChildTypes = [Mission.TYPE_SNAIL_FEAST, Mission.TYPE_EXPEDITION_FEAST, Mission.TYPE_EXPEDITION_PASS];

        Object.keys(locations).forEach((locationId) => {
            if (locationId !== "main") {
                const locationMeta = cleverapps.meta.getLocationMeta(locationId);
                let title = `${locationId} (slot${locationMeta.slotId || 0})`;

                if (locationMeta.locationConfig && locationMeta.locationConfig.available) {
                    const available = locationMeta.locationConfig.available;
                    title += ` [${available.level || available.actualLevel}lvl]`;
                }

                if (locationMeta.isActive()) {
                    const childMissionTypes = locations[locationId].filter(
                        (missionType) => expeditionChildTypes.includes(Mission.GetMissionType(missionType))
                    );

                    missionActions[ToolMenuItem.ACTIVE_ITEM + title] = new ToolFolder(() => {
                        const menu = this.getLocationMenu(locationId);

                        childMissionTypes.forEach((missionType) => {
                            const missionData = Missions[missionType];
                            const missionTitle = missionData.name || missionData.id;
                            const mission = cleverapps.missionManager.findByType(missionType);

                            if (mission) {
                                menu[ToolMenuItem.ACTIVE_ITEM + missionTitle] = this.getMissionMenu(mission);
                            } else {
                                menu[missionTitle] = this.startMission(missionData);
                            }
                        });

                        return menu;
                    });
                } else {
                    missionActions[title] = this.startLocation(locationId);
                }
            }

            locations[locationId].forEach((missionType) => {
                const missionData = Missions[missionType];

                const isChildMission = expeditionChildTypes.includes(Mission.GetMissionType(missionType));

                if (isChildMission) {
                    return;
                }

                const semaphoreNames = {
                    0: "ALWAYS",
                    1: "PRIMARY",
                    2: "SECONDARY",
                    4: "LANTERN",
                    8: "PIGGY_BANK",
                    16: "SALE",
                    32: "PRIZE_CALENDAR"
                };

                const shortenTime = (str) => str
                    .replace(/\b(hour|hours)\b/g, "h")
                    .replace(/\b(day|days)\b/g, "d")
                    .replace(/\b(minute|minutes)\b/g, "m")
                    .replace(/\b(second|seconds)\b/g, "s");

                let title = (locationId !== "main" ? `${locationId} ` : "") + (missionData.name || missionData.id);

                if (missionData.semaphore) {
                    title += ` (${semaphoreNames[missionData.semaphore]} | ${shortenTime(Mission.SEMAPHORE_COOLDOWNS[missionData.semaphore])})`;
                }

                if (missionData.cooldown) {
                    title += ` ${shortenTime(missionData.cooldown)} cooldown`;
                }

                if (missionData.schedule) {
                    const { startDate, endDate } = MissionManager.parseWeekdayRange(missionData.schedule);
                    const startDateFormatted = (startDate).toLocaleDateString("en-US", {
                        weekday: "short",
                        day: "numeric"
                    });
                    const endDateFormatted = (endDate).toLocaleDateString("en-US", {
                        weekday: "short",
                        day: "numeric"
                    });
                    title += ` (${startDateFormatted}-${endDateFormatted})`;
                }

                if (missionData.available && missionData.available.level) {
                    title += ` [${missionData.available.level}lvl]`;
                }

                const mission = cleverapps.missionManager.findByType(missionType);
                if (mission) {
                    missionActions[ToolMenuItem.ACTIVE_ITEM + title] = this.getMissionMenu(mission);
                } else {
                    missionActions[title] = this.startMission(missionData);
                }
            });
        });

        return missionActions;
    },

    getLocationMenu: function (locationId) {
        const actions = {};

        actions.finish = () => {
            const locationMeta = cleverapps.meta.getLocationMeta(locationId);
            if (locationMeta.isUnknown() || !locationMeta.isActive()) {
                return;
            }

            if (locationMeta.schedule) {
                locationMeta.schedule.finish = Date.now() + 3000;
            } else if (locationMeta.locationConfig.duration) {
                locationMeta.started = Date.now() - cleverapps.parseInterval(locationMeta.locationConfig.duration);
            }
            const expeditionIcon = cleverapps.sideBar.findExpeditionIcon(locationId);
            if (expeditionIcon) {
                expeditionIcon.resetState();
            }
            cleverapps.meta.save();
        };

        return actions;
    },

    startLocation: function (locationId) {
        return () => {
            const locationMeta = cleverapps.meta.getLocationMeta(locationId);

            cleverapps.meta.listActiveLocations().forEach((activeLocationId) => {
                const activeLocationMeta = cleverapps.meta.getLocationMeta(activeLocationId);
                if (locationMeta.slotId === activeLocationMeta.slotId) {
                    cleverapps.meta.finishLocation(activeLocationId);
                }
            });

            const feature = locationMeta.locationConfig.feature;
            if (feature && !cleverapps.eventManager.isActive(feature)) {
                cleverapps.eventManager.setCustomFeature(feature, cleverapps.parseInterval("1 day"));
            }

            const retire = locationMeta.locationConfig.retire && new Date(locationMeta.locationConfig.retire).getTime();
            if (retire && retire < Date.now()) {
                locationMeta.locationConfig.retire = new Date(Date.now() + cleverapps.parseInterval("10 day"));
            }

            cleverapps.meta.startLocation(locationId);

            cleverapps.focusManager.whenFreeFocus(() => {
                cleverapps.placements.resetThrottle();
                cleverapps.placements.run(Placements.FREE_FOCUS, {
                    skipDelayFromStart: true
                });
            });
        };
    },

    getMissionMenu: function (mission) {
        const missionActions = {};

        missionActions.finish = MissionsTool.setTimeLeft.bind(MissionsTool, mission, 2000);
        if (Missions[mission.type].schedule) {
            missionActions.setScheduleStar = MissionsTool.shiftToMission.bind(MissionsTool, mission.type);
        }

        if (mission.type === Mission.TYPE_LANTERN) {
            missionActions.setLevel = function () {
                const level = parseInt(window.prompt(`Lantern level (0...${Lantern.getMaxStreak()}):`));
                let levelCorrect = false;
                if (!isNaN(level)) {
                    if (level >= 0 && level <= Lantern.getMaxStreak()) {
                        levelCorrect = true;
                        mission.logic.lantern.streak = mission.logic.lantern.savedStreak = level;
                        mission.logic.lantern.save();
                    }
                }
                if (!levelCorrect) {
                    alert("INCORRECT LEVEL");
                }
            };
        } else if (mission.type === Mission.TYPE_TREASURE_SEARCH) {
            missionActions.viewField = function () {
                const window = cleverapps.focusManager.currentWindow();
                if (window && window.treasureSearch) {
                    const game = window.treasureSearch;
                    let s = "";
                    const fieldSize = TreasureSearch.FIELD_SIZE_BY_STAGES[game.getStage()];

                    for (let row = 0; row < fieldSize.height; row++) {
                        for (let col = 0; col < fieldSize.width; col++) {
                            let code = "-";

                            Object.keys(game.goals).forEach((type) => {
                                game.goals[type].forEach((goal) => {
                                    if (col === goal.col && fieldSize.height - row - 1 === goal.row) {
                                        code = type;
                                    }
                                });
                            });

                            s += code;
                        }
                        s += "\n";
                    }
                    alert(`TreasureSearch unopened keys/flowers:\n${s}`);
                }
            };
            missionActions.add20Shovels = function () {
                mission.updateCurrency(20);
            };
            missionActions.shovelsReset = function () {
                mission.updateCurrency(-mission.currency);
            };
            missionActions.passStage = function () {
                const window = cleverapps.focusManager.currentWindow();
                if (window && window.treasureSearch) {
                    const treasureSearch = window.treasureSearch;

                    Object.keys(treasureSearch.goals).forEach((type) => {
                        treasureSearch.goals[type].forEach((goal) => {
                            if (!treasureSearch.isOpened(goal.col, goal.row)) {
                                mission.updateCurrency(1);
                                treasureSearch.open(goal.col, goal.row);
                            }
                        });
                    });
                }
            };
        } else if (mission.type === Mission.TYPE_PRIZE_CALENDAR) {
            missionActions.reset = function () {
                mission.update(-mission.result, {});
                const win = cleverapps.focusManager.currentWindow();
                if (win && win instanceof PrizeCalendarWindow) {
                    win.tiles.forEach((tile) => {
                        tile.type = win.prizeCalendar.getTileType(tile.index);
                        tile.createContent();
                    });
                }
            };

            missionActions.open = function () {
                const win = cleverapps.focusManager.currentWindow();
                if (win && win instanceof PrizeCalendarWindow) {
                    win.prizeCalendar.onClaimTile();
                }
            };

            missionActions.setTileToLast = function () {
                mission.update(8 - mission.result);
                const win = cleverapps.focusManager.currentWindow();
                if (win && win instanceof PrizeCalendarWindow) {
                    win.tiles.forEach((tile) => {
                        tile.type = win.prizeCalendar.getTileType(tile.index);
                        tile.createContent();
                    });
                }
            };
        } else if (mission.type === Mission.TYPE_PIGGY_BANK || mission.type === Mission.TYPE_OLD_PIGGY_BANK) {
            missionActions.addBalance = function () {
                const amount = parseInt(prompt("Enter amount"));
                if (amount) {
                    cleverapps.missionManager.dispatchEvent(mission.type, { amount });
                }
            };

            missionActions.reset = function () {
                mission.logic.init();
            };
        } else if (mission.competition) {
            missionActions.set_place = function () {
                displayToolPrompt((value) => {
                    const place = parseInt(value) - 1;
                    if (isNaN(place)) {
                        return;
                    }

                    const competition = mission.runningCompetition;
                    if (!competition) {
                        return;
                    }

                    const maxResult = competition.options.algo.maxResult && competition.options.algo.maxResult - 1;

                    MissionsTool.setPlace(mission, place, maxResult);
                    MissionsTool.applyPersonalBestOffsets(competition);
                }, "Enter the place, counting from 1:");
            };

            missionActions.set_score = function () {
                displayToolPrompt((value) => {
                    const competition = mission.runningCompetition;
                    if (!competition) {
                        return;
                    }

                    const score = cleverapps.clamp(parseInt(value), 0, competition.options.algo.maxResult || Number.MAX_VALUE);
                    if (isNaN(score)) {
                        return;
                    }

                    if (competition) {
                        const player = competition.results.find((res) => res.player);
                        mission.update(score - player.amount, undefined, true);
                    }
                }, "Enter score:");
            };

            missionActions.win_place = function () {
                displayToolPrompt((value) => {
                    const place = parseInt(value) - 1;
                    if (isNaN(place)) {
                        return;
                    }

                    MissionsTool.setPlace(mission, place);

                    if (![Mission.TYPE_SPACE_RACE].includes(mission.type)) {
                        if (mission.runningCompetition) {
                            mission.runningCompetition.stop();
                        }

                        MissionsTool.setTimeLeft(mission, 2000);
                    }
                }, "Enter the place, counting from 1:");
            };

            missionActions.win_1_native = function () {
                const competition = mission.runningCompetition;
                if (!competition) {
                    return;
                }

                const results = competition.getResults();
                if (results.length) {
                    mission.update(competition.options.algo.maxResult || 1000, undefined, true);
                }

                if (mission.logic && mission.logic.competitionTimeLeft) {
                    const competitionTimeLeft = mission.logic.competitionTimeLeft();
                    DateShift.setShift(DateShift.getDelta() + competitionTimeLeft - 2000);
                } else if (![Mission.TYPE_SPACE_RACE].includes(mission.type)) {
                    competition.stop();
                    MissionsTool.setTimeLeft(mission, 2000);
                }
            };

            missionActions.lose = function () {
                const competition = mission.runningCompetition;
                if (!competition) {
                    return;
                }

                let updated = false;
                const results = competition.getResults();
                if (results.length) {
                    const maxResult = competition.options.algo.maxResult && competition.options.algo.maxResult || 1000;

                    mission.setResult(0);

                    const bots = results.filter((r) => !r.player).sort((a, b) => b.amount - a.amount);

                    for (let j = 4; j >= 0; j--) {
                        if (bots[j]) {
                            competition.updatePlayerResult(bots[j].id, Math.max(maxResult - j, 0));
                        }
                    }

                    updated = true;
                }

                const competitionRounds = [Mission.TYPE_SPACE_RACE].includes(mission.type);
                if (!updated || competitionRounds) {
                    return;
                }

                if (mission.logic && mission.logic.competitionTimeLeft) {
                    const competitionTimeLeft = mission.logic.competitionTimeLeft();
                    DateShift.setShift(DateShift.getDelta() + competitionTimeLeft - 2000);
                } else {
                    MissionsTool.setTimeLeft(mission, 2000);
                }
            };
        } else if (mission.type === Mission.TYPE_PINBALL) {
            missionActions.addChips = function () {
                const amount = parseInt(prompt("Enter amount", 10));
                mission.logic.updateChips(amount);
            };

            missionActions.addChips10 = function () {
                mission.logic.updateChips(10);
            };

            missionActions.addTickets = function () {
                const amount = parseInt(prompt("Enter amount", 10));
                mission.logic.updateTickets(amount);
                mission.logic.pinball.win();
            };

            missionActions.addTickets250 = function () {
                mission.logic.updateTickets(250);
                mission.logic.pinball.win();
            };

            missionActions.setExtraBarrierStages = function () {
                const amount = parseInt(prompt("Enter the number of stages", 1));
                ExtraBarrier.STAGES = amount;
            };

            missionActions.toggleProgressBarText = function () {
                mission.logic.pinball.trigger("toggleProgressBarText");
            };
        } else if (mission.type === Mission.TYPE_OCTOPUS_HUNT) {
            missionActions.goToStage = function () {
                const stage = parseInt(prompt("Enter stage", 10));
                mission.update(stage - mission.result - 1);

                cleverapps.refreshScene();
            };

            missionActions.winRound = function () {
                const octopusHuntSceneComponent = ComponentMap.getByName(cleverapps.Scenes.GetRunningScene(), "OctopusHuntSceneComponent");
                const game = octopusHuntSceneComponent && octopusHuntSceneComponent.octopusHuntGame;

                const reward = game.stageRewards.find((reward) => !reward.octopus);

                PseudoRandom.GET().choose(game.barrels).collectReward(reward);
            };

            missionActions.loseRound = function () {
                const sceneComponent = cleverapps.Scenes.GetSceneComponent(OctopusHuntSceneComponent);
                const game = sceneComponent.octopusHuntGame;

                const reward = game.stageRewards.find((reward) => reward.octopus);

                if (!reward) {
                    alert("Can't lose bonus round!");
                    return;
                }

                sceneComponent.octopusHunt.handleOctopus();
                PseudoRandom.GET().choose(game.barrels).collectReward(reward);
            };
        } else if (mission.type === Mission.TYPE_LEVEL_MASTERY) {
            missionActions.addLevel = function () {
                mission.logic.level += 1;
                mission.logic.update();

                mission.logic.trigger("updateLevel");
            };

            missionActions.add10Levels = function () {
                mission.logic.level += 10;
                mission.logic.update();

                mission.logic.trigger("updateLevel");
            };

            missionActions.setStage = function () {
                const stage = parseInt(window.prompt(`Level Mastery stage (1...${mission.logic.getMaxStage() + 1}):`)) - 1;
                mission.logic.level = 0;
                mission.logic.stage = stage;
                mission.logic.update();
                mission.logic.trigger("updateLevel");
                mission.logic.trigger("updateStage", true);
            };

            missionActions.reset = function () {
                mission.logic.level = 0;
                mission.logic.stage = 0;
                mission.logic.update();
                mission.logic.trigger("updateLevel");
                mission.logic.trigger("updateStage", true);
            };

            missionActions.collectReward = function () {
                cleverapps.placements.data.levelMasteryRewardCollect.action();
            };
        } else if (mission.type === Mission.TYPE_HUNGRY_GAMES) {
            delete missionActions.setScheduleStar;

            missionActions.nextStage = function () {
                cleverapps.focusManager.closeAllWindows();
                MissionsTool.hungryGamesSetLevel(mission, mission.result + 1);
            };

            missionActions.lose = function () {
                cleverapps.focusManager.closeAllWindows();
                cleverapps.missionManager.trigger("hungryGamesRemoveOrder", mission);
                mission.logic.loseCompetition();
            };

            missionActions.expireOrderTimer = function () {
                const customer = typeof HungryGamesCustomer !== "undefined" && HungryGamesCustomer.findCustomer();
                if (!customer || customer.getCustomer().getState() !== Customer.STATE_RECIPE) {
                    return;
                }

                customer.levelStartTime = Date.now() - customer.duration + 2000;
                customer.unit.save();
                customer.startLevelTimeout();

                const view = customer.getCustomer().view;
                if (view) {
                    view.removeAdditionalViews();
                    view.restoreState();
                }

                Map2d.currentMap.customers.onUpdateOrder(customer.getCustomer());
            };

            missionActions.win = function () {
                cleverapps.focusManager.closeAllWindows();
                cleverapps.missionManager.trigger("hungryGamesRemoveOrder", mission);
                mission.setResult(HungryGamesLogic.LEVELS_AMOUNT - 1);
            };

            missionActions.reset = function () {
                mission.logic.lostTime = undefined;
                mission.logic.competitionStart = undefined;
                mission.setResult(0);
                mission.logic.setState(HungryGamesLogic.STATES.IDLE);
                mission.logic.previousLevel = undefined;
            };

            missionActions.openWindow = ToolFolder.create(() => {
                const open = function (focus, WindowClass, args) {
                    cleverapps.focusManager.closeAllWindows();
                    cleverapps.focusManager.display({
                        focus,
                        action: function (f) {
                            new WindowClass(...(args || []));
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                };

                return {
                    startWindow: () => open("HungryGamesStartWindow", HungryGamesStartWindow, [mission]),
                    cooldownWindow: () => open("HungryGamesCooldownWindow", HungryGamesCooldownWindow, [mission]),
                    window: () => open("HungryGamesWindow", HungryGamesWindow, [mission]),
                    startCompetitionWindow: () => open("HungryGamesStartCompetitionWindow", HungryGamesStartCompetitionWindow),
                    guideWindow: () => open("HungryGamesGuideWindow", HungryGamesGuideWindow),
                    rewardWindow: function () {
                        const winners = mission.logic.calcPlayersForLevel(HungryGamesLogic.LEVELS_AMOUNT);
                        const reward = RewardsConfig.HungryGames;
                        const amount = Math.floor(reward.value / winners);
                        open("HungryGamesRewardWindow", HungryGamesRewardWindow, [mission, { reward: { [reward.type]: amount }, amount, winners }]);
                    }
                };
            });
        } else if ((typeof IslandDecorationLogic !== "undefined") && (mission.logic instanceof IslandDecorationLogic)) {
            missionActions.addStars1000 = function () {
                mission.update(1000);
            };
            missionActions.addStars = function () {
                displayToolPrompt((value) => {
                    const stars = parseInt(value);
                    if (Number.isFinite(stars)) {
                        mission.update(stars);
                    }
                }, "Enter number of stars", 5000);
            };
        }

        if (mission.type === Mission.TYPE_ROYAL_LEAGUE) {
            Object.assign(missionActions, MissionsTool.getRoyalLeagueMenu(mission));
        }

        missionActions.makeUnknown = function () {
            cleverapps.setUrlHash({ forgetMission: mission.type });
            window.location.reload();
        };

        return missionActions;
    },

    hungryGamesSetLevel: function (mission, level) {
        if (!mission.isRunning() || !mission.logic.isRunning() || level === mission.result) {
            return;
        }

        cleverapps.missionManager.trigger("hungryGamesRemoveOrder", mission);
        mission.update(level - mission.result);

        const customer = typeof HungryGamesCustomer !== "undefined" && HungryGamesCustomer.findCustomer();
        if (customer) {
            customer.getCustomer().reset();
            customer.getCustomer().onUpdateState();
        }

        if (mission.logic.state === HungryGamesLogic.STATES.ACTIVE) {
            cleverapps.missionManager.trigger("hungryGamesStartNextOrder", mission);
        }
    },

    getRoyalLeagueMenu: function (mission) {
        const logic = mission.logic;

        const addScore = function (value) {
            if (value > 0) {
                logic.earnPoints(value);
            }
        };

        const winLevel = function (tag) {
            addScore(RoyalLeagueLevelsAdapter.POINTS[tag]);
            RoyalLeagueLevelsAdapter.nextRound(mission);
            RoyalLeagueLevelsAdapter.updatePlayButton(mission);
        };

        return {
            addScore: function () {
                displayToolPrompt((value) => addScore(parseInt(value)), "Enter score to add:");
            },

            nextStage: function () {
                const stage = logic.getStages()[logic.getReachedStages()];
                if (stage) {
                    addScore(stage.points - mission.result);
                }
            },

            nextTier: function () {
                const points = RoyalLeagueLogic.TIERS[logic.getTier()];
                if (points) {
                    addScore(points - mission.result);
                }
            },

            nextRound: function () {
                RoyalLeagueLevelsAdapter.nextRound(mission);
                RoyalLeagueLevelsAdapter.updatePlayButton(mission);
            },

            winLevel: ToolFolder.create(() => ({
                simple: () => winLevel("default"),
                tricky: () => winLevel("tricky"),
                hard: () => winLevel("hard")
            })),

            claimStage: function () {
                cleverapps.focusManager.displayWhenFreeFocus({
                    focus: "RoyalLeagueToolClaimStage",
                    action: function (f) {
                        const prize = logic.claimStage();
                        if (!prize) {
                            f();
                            return;
                        }

                        Mission.createRewardWindow(prize, mission);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            },

            reset: function () {
                mission.setResult(0);
                logic.claimed = 0;
                mission.details.round = 0;
                cleverapps.missionManager.save();

                RoyalLeagueLevelsAdapter.updatePlayButton(mission);
            },

            info: function () {
                console.log({
                    score: mission.result,
                    place: mission.getSummary().place + 1,
                    round: RoyalLeagueLevelsAdapter.getRound(mission),
                    tier: logic.getTier(),
                    reachedStages: logic.getReachedStages(),
                    claimedStages: logic.claimed,
                    joined: new Date(logic.joined),
                    finish: new Date(mission.finishTime())
                });
            }
        };
    },

    startMission: function (missionData) {
        return () => {
            const siblingMission = cleverapps.missionManager.findBySemaphore(missionData.semaphore);
            if (siblingMission) {
                cleverapps.missionManager.remove(siblingMission);
            }

            const feature = missionData.feature;
            if (feature && !cleverapps.eventManager.isActive(feature)) {
                cleverapps.eventManager.setCustomFeature(feature, cleverapps.parseInterval("1 day"));
            }

            if (missionData.schedule) {
                MissionsTool.shiftToMission(missionData.type);
            }

            cleverapps.missionManager.planMission(missionData.type);

            cleverapps.focusManager.whenFreeFocus(() => {
                cleverapps.missionManager.pendingStartWindow = function () {
                    const mission = cleverapps.missionManager.findByType(missionData.type);
                    return cleverapps.missionManager.hasPendingStartWindow(mission) && mission;
                };
                cleverapps.placements.resetThrottle();
                cleverapps.placements.run(Placements.FREE_FOCUS, {
                    skipDelayFromStart: true
                });
                delete cleverapps.missionManager.pendingStartWindow;
            });
        };
    },

    getLastRemoved: function () {
        const actions = {};
        const fn = function (type) {
            if (Missions[type].oncePerEvent) {
                for (const id in cleverapps.missionManager.lastRemoved) {
                    if (Missions[type].semaphore === Missions[id].semaphore) {
                        delete cleverapps.missionManager.lastRemoved[id];
                    }
                }
            } else {
                delete cleverapps.missionManager.lastRemoved[type];
            }
            cleverapps.missionManager.save();
            cleverapps.toolModel.refresh();
        };

        for (const type in cleverapps.missionManager.lastRemoved) {
            const name = Missions[type].name;
            actions[name] = fn.bind(undefined, type);
        }

        return actions;
    },

    setTimeLeft: function (mission, timeRemain) {
        if (mission.finish) {
            mission.finish = Date.now() + timeRemain;
        } else if (mission.schedule) {
            DateShift.setShift(DateShift.getDelta() + mission.getTimeLeft() - timeRemain);
        } else if (mission.feature && !mission.duration) {
            if (mission.oncePerEvent) {
                mission.eventFinishTime = Date.now() + timeRemain;
            } else {
                cleverapps.eventManager.setCustomFeature(mission.feature, timeRemain);
            }
        } else {
            mission.started = Date.now() - cleverapps.parseInterval(mission.duration) + timeRemain;
        }

        mission.onUpdateState();
        cleverapps.missionManager.save();
    },

    shiftToMission: function (type) {
        const currentDate = DateShift.realDate();
        const { startDate } = MissionManager.parseWeekdayRange(Missions[type].schedule);

        DateShift.setShift(startDate.getTime() - currentDate.getTime());
    },

    setPlace: function (mission, place, maxResult) {
        const competition = mission.runningCompetition;
        if (competition) {
            const bots = competition.results.filter((r) => !r.player).sort((a, b) => b.amount - a.amount);
            const player = competition.results.find((r) => r.player);

            const players = bots.slice();
            players.splice(place, player, 1);

            const maxAmount = maxResult || competition.options.algo.maxResult || Math.max(...competition.results.map((r) => r.amount), place + 1);

            const playerAmount = maxAmount - place;

            for (let j = players.length - 1; j >= 0; j--) {
                if (j > place) {
                    if (players[j].amount >= playerAmount) {
                        competition.updatePlayerResult(players[j].id, Math.max(playerAmount - 1, 0));
                    }
                } else if (j < place) {
                    competition.updatePlayerResult(players[j].id, maxAmount - j);
                } else {
                    mission.setResult(playerAmount, undefined, true);
                }
            }

            competition.save();
        }
    },

    applyPersonalBestOffsets: function (competition) {
        const algo = competition.algorithm;
        if (!(algo instanceof PersonalBestBotAlgorithm)) {
            return;
        }

        const natural = {};
        competition.updatePlayerResult = function (id, amount) {
            natural[id] = amount;
        };
        competition.save = function () {};
        PersonalBestBotAlgorithm.prototype.process.call(algo);
        delete competition.updatePlayerResult;
        delete competition.save;

        const offsets = {};
        competition.results.forEach((r) => {
            if (r.player) {
                return;
            }
            const offset = Math.max(0, r.amount - (natural[r.id] || 0));
            if (offset > 0) {
                offsets[r.id] = offset;
            }
        });

        delete algo.process;

        if (Object.keys(offsets).length === 0) {
            return;
        }

        algo.process = function () {
            const origUpdate = competition.updatePlayerResult;
            competition.updatePlayerResult = function (id, amount) {
                origUpdate.call(this, id, amount + (offsets[id] || 0));
            };
            PersonalBestBotAlgorithm.prototype.process.call(this);
            delete competition.updatePlayerResult;
        };
    }
};

(function () {
    const baseInit = Mission.initialize;
    Mission.initialize = function (...args) {
        baseInit.call(undefined, ...args);

        const params = cleverapps.getRequestParameters(location.hash);
        if (params.forgetMission !== undefined) {
            cleverapps.setUrlHash({ forgetMission: undefined });
            if (Missions[params.forgetMission]) {
                const missionType = Mission.GetMissionType(params.forgetMission);
                console.warn(`Mission ${Missions[missionType].name} was made unknown, reload to restore`);
                delete Missions[missionType];
            }
        }
    };
}());